var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconLayers(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.50178 10.1846C3.51589 9.39024 2.52295 8.99306 2.52295 8.49951C2.52295 8.00596 3.51589 7.60878 5.50178 6.81443L8.31025 5.69104C10.2961 4.89669 11.289 4.49951 12.5229 4.49951C13.7568 4.49951 14.7497 4.89669 16.7356 5.69104L19.5441 6.81443C21.53 7.60878 22.5229 8.00596 22.5229 8.49951C22.5229 8.99306 21.53 9.39024 19.5441 10.1846L16.7356 11.308C14.7497 12.1023 13.7568 12.4995 12.5229 12.4995C11.289 12.4995 10.2961 12.1023 8.31025 11.308L5.50178 10.1846Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5229 12.4995C22.5229 12.4995 21.53 13.3902 19.5441 14.1846L16.7356 15.308C14.7497 16.1023 13.7568 16.4995 12.5229 16.4995C11.289 16.4995 10.2961 16.1023 8.31025 15.308L5.50178 14.1846C3.51589 13.3902 2.52295 12.4995 2.52295 12.4995",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5229 16.4995C22.5229 16.4995 21.53 17.3902 19.5441 18.1846L16.7356 19.308C14.7497 20.1023 13.7568 20.4995 12.5229 20.4995C11.289 20.4995 10.2961 20.1023 8.31025 19.308L5.50178 18.1846C3.51589 17.3902 2.52295 16.4995 2.52295 16.4995",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLayers);
export default __webpack_public_path__ + "static/media/icon-layers.59323939ef5290c3b09261133a78f02f.svg";
export { ForwardRef as ReactComponent };